<template>
  <div>
    <div class="banner">
      <b-container class="col-sm-12 banner_box">
        <div>
          <h1 class="banner-h1">Let's Get Started!</h1>
          <p class="banner-p">SL360 offers a suite of privacy-safe, easy-to-use data services that help you execute your business' marketing more efficiently and at higher returns. Choose your desired service below to begin.</p>
        </div>
        

      </b-container>
    </div>

    <div class="reach">
      <b-container class="col-sm-12">
        <b-row>
          <div class="col-sm-3 landing_icon_box">
            <icon name="users" class="landing_icon" scale="8" />
          </div>
          <div class="col-sm-9">
            <div class="row reach-title">
              <h1 class="reach-h2">Order New Prospects</h1>
              <p class="reach-h2-desc">Build, order, and receive a targeted list of prospects for your next marketing campaign in minutes.</p>
            </div>

            <b-row v-if="topDataSource.length > 0" class="landing_source_box">
              <div class="landing_source" v-for="item in topDataSource" :key="item.ListType">
                <b-btn class="btn-primary landing-btn" @click="next(item.ListType)">{{ item.Desc.toUpperCase() }}</b-btn>
              </div>
              <div class="landing_source" v-if="otherDataSource.length > 0">
                <select v-model="valSource" class="landing_select" @change="next(valSource)">
                  <option value="o" selected="selected">OTHER</option>
                  <option v-for="item in otherDataSource" :value="item.ListType">
                    {{ item.Desc.toUpperCase() }}
                  </option>
                </select>
              </div>
            </b-row>
          </div>
        </b-row>


      </b-container>
    </div>

    <div class="enhance">
      <b-container class="col-sm-12">
        <b-row class="serivce_row"
          v-if="userServiceDataSources.showEnhanceList || userServiceDataSources.showCleanList || userServiceDataSources.showPortraitReports">
          <div class="landing_service" v-if="userServiceDataSources.showEnhanceList">
            <icon name="pie-chart" class="landing_icon" scale="8" />
            <h1 class="reach-h2">Enhance Data</h1>
            <p class="reach-h2-desc">Enhance your customer database with added demographic, psychographic, and contact
              details.</p>
            <b-btn class="btn-primary landing-btn" @click="nextService('enhanceList')">Get Started</b-btn>
          </div>
          <div class="landing_service" v-if="userServiceDataSources.showCleanList">
            <icon name="check-circle" class="landing_icon" scale="8" />
            <h1 class="reach-h2">Clean & Verify</h1>
            <p class="reach-h2-desc">Update your database's contact details while identifying records with privacy
              considerations.</p>
            <b-btn class="btn-primary landing-btn" @click="nextService('cleanList')">Get Started</b-btn>
          </div>
          <div class="landing_service" v-if="userServiceDataSources.showPortraitReports">
            <icon name="bar-chart" class="landing_icon" scale="8" />
            <h1 class="reach-h2">Analyze Customers</h1>
            <p class="reach-h2-desc">Uncover customer demographics, psychographics, and spot potential new leads through
              customer portrait reports.</p>
            <b-btn class="btn-primary landing-btn" @click="nextService('portaitreports')">Get Started</b-btn>
          </div>
        </b-row>
      </b-container>

    </div>
  </div>
</template>

<script>
import MSectionService from '@/components/landings/MSectionService'

export default {
  components: {
    MSectionService
  },
  data() {
    return {
      valSource: 'o',
      item: {},
      status: this.$store.state.user
    }
  },
  computed: {
    topDataSource() {
      let result = []
      let others = []
      for (let item of this.status.userDataSources) {
        if (item.ListType === 10 || item.ListType === 260 || item.ListType === 130) {
          result.push(item)
        }else if (others.length < 3){
          others.push(item)
        }
      }
      // fill three data sources
      if (result.length < 3){
        const expectedLength = Math.min(3 - result.length, others.length)
        for (let i = 0; i < expectedLength; i++) {
           result.push(others.at(i))
        }
      }

      return result
    },
    otherDataSource() {
      let result = []
      let topDatasources = this.topDataSource
      for (let item of this.status.userDataSources) {
         const d = topDatasources.find( topDatasource => topDatasource.ListType === item.ListType)
         if (!d) {
            result.push(item)
         }
        /*
        if (item.ListType !== 10 && item.ListType !== 260 && item.ListType !== 130) {
          result.push(item)
        }
        */
      }
      return result
    },
    userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources
    },
  },
  methods: {
    next(listType) {
      if (listType !== null && listType !== undefined && listType !== 'o') {
        this.$router.push({
          name: 'order',
          params: {
            listType: listType
          }
        })
      }

    },
    nextService(listType) {
      if (listType !== null && listType !== undefined) {
        window.location.href = this.$store.getters['config/link'](listType)
      }

    },
  }

}
</script>

<style scoped lang="scss">
.banner {
  background: $color-header-background;
  padding-top: 70px;
  padding-bottom: 200px;
  background-size: 100% 100%;
}

.banner-h1 {
  font-size: 48px;
  color: $color-white;
  font-weight: bold;
}

.banner-h2 {
  font-size: 24px;
  color: $color-white;
  margin-bottom: 0;
  font-weight: bold;
}

.points {
  font-size: 48px;
  color: $color-primary-deep;
}

.banner-p {
  font-size: 24px;
  margin-top: 14px;
  color: $color-border;

}


.reach {
  width: 80%;
  padding-top: 50px;
  padding-bottom: 50px;
  margin: -160px auto 0;
  background-color: white;
  border-radius: 10px;
  text-align: center;
  box-shadow: 1px 2px 10px 1px rgba(0, 0, 0, 0.1);
}

.enhance {
  width: 80%;
  padding-bottom: 50px;
  margin: 30px auto 0;
  border-radius: 10px;
  text-align: center;
}


.reach-block {
  display: flex;
  padding: 30px 0;
}

.landing_icon_box {
  text-align: center;
  padding-right: 0px;
}

.landing_icon {
  color: $color-primary-deep;
  background-color: #EBF5F6;
  border-radius: 10px;
  padding: 20px;
  height: 90px;
  width: 90px;
}

.reach-card {
  position: relative;
  background-image: url('http://dev.sl360.com/main/landConsumer.jpg');
  background-size: 100% auto;
  padding: 16px;
  padding-bottom: 32px;
  width: 40%;
}

.reach-card-title {
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 24px;
  color: #fff;
}

.reach-card-text {
  color: #fff;
}

.landing-btn {
  font-size: 20px;
  text-transform: uppercase;
  min-width: 180px;
  padding: 16px 0;
}

.landing_source_box {
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
}

.landing_source {
  padding-left: 0;
  margin: 10px 0;
  padding-right: 0;
  min-width: 180px;
}


select:focus {
  outline: none;
}

.reach-h2 {
  font-weight: bold;
}

.landing_service {
  padding-left: 0;
  margin: 10px 0;
  border-radius: 10px;
  min-height: 200px;
  background-color: $color-white;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-shadow: 1px 2px 10px 1px rgba(0, 0, 0, 0.1);
}

.banner_box {
  display: flex;
  width: 80%;
  padding-left: 0;
  padding-right: 0;
  flex-direction: column;
}

.serivce_row {
  justify-content: space-between;
}

.reach-title {
  display: flex;
  flex-direction: column;
}
.nav-link:first-child{
  color: $color-primary;
}

.banner_point {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  margin-left: 20px;
}
.btn-reward{
  font-size: 16px;
  padding: 10px 0;
}

@media(min-width: 913px) {
  .landing_service {
    padding: 50px;
    width: 30%;
  }

  .reach {
    text-align: left;
  }

  .landing_icon {
    color: $color-primary-deep;
    background-color: #EBF5F6;
    border-radius: 10px;
    padding: 20px;
    height: 128px;
    width: 128px;
    margin: 10px;
  }

  .landing_source_box {
    justify-content: space-between;
  }
}

@media (min-width: 768px) {
  .reach {
    text-align: left;
  }

  .banner_box {
    flex-direction: row;
  }

  .banner_point {
    align-items: end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landings/MV5.vue